import React from 'react';
import { Stack } from '@mui/material';
import StyledWrapper from 'pages/WorkSchedulesPlanner/RangeScaleDays/Wrapper.styled';
import EmployeeDayScale from './EmployeeDayScale/EmployeeDayScale';
import EmployeeSummary from './EmployeeSummary/EmployeeSummary';
import { PlannerEmployee } from '../interfaces';

interface EmployeeWorkScheduleProps {
  employee: PlannerEmployee;
  rangeDays: Date[];
  hideBorderTop: boolean;
  currentDate: Date;
}

export default function EmployeeWorkSchedule({
  employee,
  rangeDays,
  hideBorderTop,
  currentDate,
}: EmployeeWorkScheduleProps) {
  return (
    <Stack
      direction="row"
      width="100%"
      borderTop={hideBorderTop ? 'none' : '0.1rem solid'}
      borderBottom="0.1rem solid"
      borderColor="border.main"
      bgcolor="background.list"
    >
      <StyledWrapper direction="row">
        <EmployeeSummary employee={employee} />
      </StyledWrapper>
      <Stack direction="row" width="100%">
        {rangeDays.map((day) => (
          <EmployeeDayScale
            key={day.toISOString()}
            startDate={day}
            currentDate={currentDate}
            employee={employee}
          />
        ))}
      </Stack>
    </Stack>
  );
}
